import ResetPasswordBlock from './ResetPasswordBlock';
import { ResetPasswordBlockProps, ResetPasswordBlockValueProps } from './types';

export type { ResetPasswordBlockProps, ResetPasswordBlockValueProps };
export default ResetPasswordBlock;
